export const RenderNA = () => {
  return <div className="text-sm text-gray-300">N/A</div>
}
